import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const shopApi = createApi({
  reducerPath: 'shopApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://panel.linket.me/api/shop' }),
  tagTypes: ['Shop'],

  endpoints: (builder) => ({
    getShop: builder.query({
      query: () => `/getShop`,
    }),
    getProduct: builder.query({
      query: (id) => `/getProduct/${id}`,
    }),
  }),
})

export const { useGetShopQuery , useGetProductQuery } = shopApi